import React from "react";

export default function AdvisoryNote({ children }) {
  return (
    <div className="advisory-note mt-2" data-testid="advisory-note">
      <p className="font-display text-lg leading-relaxed text-[var(--ink-heading)]">
        {children}
      </p>
      <p className="mt-4 text-xs text-[var(--ink-mono)] tracking-[0.18em] uppercase">
        AI may suggest · Authorised reviewers decide · KATLAS signs the receipt
      </p>
    </div>
  );
}
